import { Navigate, Route, Routes } from "react-router-dom";

import Practices from "../Practice";
import AssignmentDetail from "./AssignmentDetail";
import EnvelopeAssignmentDetail from "./EnvelopeAssignmentDetail";
import EnvelopeSubjects from "./EnvelopeSubjects";
import EnvelopeSuperTopics from "./EnvelopeSuperTopics";
import Subjects from "./Subjects";
import Themes from "./Themes";

const EnvelopeRoutes = () => (
  <Routes>
    <Route index element={<Subjects />} />

    <Route path="/cviceni/*" element={<Practices />} />

    <Route path="/:themeId" element={<Themes />} />
    <Route path="/:themeId/:assignmentId" element={<AssignmentDetail key={Math.random()} />} key={Math.random()} />
    <Route path="/detail/:assignmentId" element={<AssignmentDetail />} />

    <Route path="obalka/:envelopeId" element={<EnvelopeSubjects />} />
    <Route path="obalka/:envelopeId/:userThemeId" element={<EnvelopeSuperTopics />} />
    <Route path="obalka/:envelopeId/:userThemeId/:userAssignmentId" element={<EnvelopeAssignmentDetail />} />

    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default EnvelopeRoutes;
